export default __webpack_public_path__ + "static/media/fb.27225f62.jpg";